export default {
  setAllVariations (state, data) {
    state.allVariations = data
  },
  setRelatedVariationData (state, data) {
    state.relatedVariationData = data
  },
  setVariationsActive (state, data) {
    state.variationsActive = data
  },
  setListingVariationGroupCombos (state, data) {
    state.listingVariationGroupCombos = data
  },
  setVariationFilterQueryStringVar (state, data) {
    state.variationFilterQueryStringVar = data
  },
  setActiveVariationFilters (state, data) {
    if (data === null) {
      data = []
    }
    state.activeVariationFilters = data
  },
  setVariationRecordsUsed (state, data) {
    state.variationRecordsUsed = data
  },
  setProductVariationInfoData (state, data) {
    state.productVariationInfoData = data
  },
  setVariationMergeDuplicateValuesByName (state, data) {
    state.variationMergeDuplicateValuesByName = data
  }
}
